// components/UserForm.jsx
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addUser, updateUser } from '../store/userSlice';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button/Button';
import { Textarea } from '../components/ui/Textarea';
import { FormLayout } from '../components/Layout/FormLayout';
import { useNavigate,useParams } from 'react-router-dom';
import { Select } from '../components/ui/Select';


export function UserForm() {
  const dispatch = useDispatch();
  let { id } = useParams();
  const existing = useSelector(state =>
    state.users.find((i)=>i.id == id)
  );
console.log(existing)
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    name: '',
    username: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    gender: '',
    dob: '',
    address: '',
    role: '',
  });

  useEffect(() => {
    if (existing) {
      setFormData({
         name: existing.full_name,
    username: existing.username,
    email: existing.email,
    phone: existing.phone_number,
    password: '',
    confirmPassword: '',
    gender: existing.gender,
    dob: existing.date_of_birth,
    address: existing.address,
    role: existing.user_role,
      });
    }
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (!id && formData.password !== formData.confirmPassword) {
      alert('Passwords do not match.');
      return;
    }

    const userToSave = { ...formData };
    delete userToSave.confirmPassword;

    if (id) {
      dispatch(updateUser({ id: id, ...userToSave }));
    } else {
      dispatch(addUser(userToSave));
    }

    navigate('/users');
    resetForm();
  };

  const resetForm = () => {
    setFormData({
      name: '',
      username: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      gender: '',
      dob: '',
      address: '',
      role: '',
    });
  };

  return (
    <FormLayout
      title={id ? 'Update User' : 'Register User'}
      description="Please fill out the fields below."
      onSubmit={handleSubmit}
      footer={
        <>
          <Button type="button" variant="ghost" onClick={()=>navigate(-1)}>
            Cancel
          </Button>
          <Button type="submit">{id ? 'Update' : 'Register'}</Button>
        </>
      }
    >
      <Input
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="Full Name"
        label="Full Name"
        required
      />
      <Input
        name="username"
        value={formData.username}
        onChange={handleChange}
        placeholder="Username"
        label="Username"
        required
      />
      <Input
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="Email Address"
        label="Email Address"
        required
      />
      <Input
        name="phone"
        type="tel"
        value={formData.phone}
        onChange={handleChange}
        label="Phone Number"
        placeholder="Phone Number"
      />
      <Input
        name="password"
        type="password"
        label="Password"
        value={formData.password}
        onChange={handleChange}
        placeholder="Password"
        required={!id}
      />
      <Input
        name="confirmPassword"
        type="password"
        label="Confirm Password"
        value={formData.confirmPassword}
        onChange={handleChange}
        placeholder="Confirm Password"
        required={!id}
      />
      <Select  options={['Male', 'Female', 'Other']} name="gender" value={formData.gender} onChange={handleChange} label="Gender"/>
      
      <Input
        name="dob"
        type="date"
        label="Date of Birth"
        value={formData.dob}
        onChange={handleChange}
      />
      <Textarea
        name="address"
        value={formData.address}
        onChange={handleChange}
        label="Address"
        placeholder="Address"
        rows={2}
      />
      <Input
        name="role"
        label="Role"
        value={formData.role}
        onChange={handleChange}
        placeholder="Role (e.g., Admin)"
      />
    </FormLayout>
  );
}
